import { render, staticRenderFns } from "./borrowBack.vue?vue&type=template&id=d6582482&scoped=true&"
import script from "./borrowBack.vue?vue&type=script&lang=js&"
export * from "./borrowBack.vue?vue&type=script&lang=js&"
import style0 from "./borrowBack.vue?vue&type=style&index=0&id=d6582482&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6582482",
  null
  
)

export default component.exports